var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('div',{staticClass:"container"},[_vm._l((_vm.items),function(item){return [_c('ClassifyItem',{key:item.id,attrs:{"classify":item,"value":_vm.values[item.id],"leftWidth":_vm.leftWidth},on:{"change":_vm.onChange}})]}),_vm._t("date")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }